import React from "react";
import Start_Background from "./Start_Background";
import Start_Main from "./Start_Main";

class Start extends React.Component {
    render() {
        return(
            <div className="start">
                <Start_Background />
                <Start_Main />
            </div>
        )
    }
}

export default Start;